<template>
  <transition name="fade">
    <div v-show="showButton" class="to-top-container" @click="scrollToTop">
      <van-icon name="back-top" class="icon" />
    </div>
  </transition>
</template>

<script>
export default {
  name: "BackToTop",
  data() {
    return {
      scrollThreshold: 200, // 显示按钮的滚动阈值
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showButton() {
      
      return this.show || window.scrollY > this.scrollThreshold;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    scrollToTop() {
      const duration = 300; // 滚动动画持续时间（毫秒）
      const start = window.scrollY;
      const startTime =
        "now" in window.performance ? performance.now() : new Date().getTime();

      const animateScroll = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1); // 计算进度
        const easeInOutQuad = (t) =>
          t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; // 缓动函数
        const scrollPosition = start * (1 - easeInOutQuad(progress)); // 计算滚动位置

        window.scrollTo(0, scrollPosition);

        if (elapsedTime < duration) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    },
  },
};
</script>

<style scoped lang="less">
.to-top-container {
  position: fixed;
  right: 20px;
  bottom: 50px;
  z-index: 999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #4c9673;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.3s;
}

.to-top-container:hover {
  background-color: #347f5e;
}

.icon {
  color: white;
  font-size: 24px;
  transform: translateY(-1px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
